package com.exura.features.demofeatures.domain.model

enum class FeatureName(val id: String) {
    PLAN_PUBLISH("plan_publish");

    companion object {
        fun fromId(id: String): FeatureName? = entries.find { it.id == id }
    }
}
